import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { createTaxRate } from "../../api/apiTax";
import parseError from "../../utils/parseError";

export const useCreateTaxRate = () => {
    const queryClient = useQueryClient();

    const { mutate: createTaxRateMutate, isPending: isCreating } = useMutation({
        mutationFn: createTaxRate,
        onSuccess: (res) => {
            toast.success(res.message || "Tax rate created successfully");
            queryClient.invalidateQueries(["tax-rates"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to create tax rate");
        },
    });

    return { createTaxRateMutate, isCreating };
};
